import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import EmergencyCleanupPage from '@/pages/emergency-cleanup/page';
import PropertyRestorationPage from '@/pages/property-restoration/page';
import PipeLeakDrainagePage from '@/pages/pipe-leak-drainage/page';
import ContactPage from '@/pages/contact/page';
import ServiceRequestPage from '@/pages/service-request/page';
import CustomerInformationPage from '@/pages/customer-information/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/emergency-cleanup', element: <EmergencyCleanupPage /> },
  { path: '/property-restoration', element: <PropertyRestorationPage /> },
  { path: '/pipe-leak-drainage', element: <PipeLeakDrainagePage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/service-request', element: <ServiceRequestPage /> },
  { path: '/customer-information', element: <CustomerInformationPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
